const crypto = require('crypto');
let secretkey = "b18c7f94a4365f35e8"; //唯一（公共）秘钥
import {getcookies,sendusenum,login,sendlogin} from 'network/app.js'
import {
  d_getmods,
  d_getmats,
  d_getmaps,
  getappid
} from 'network/seek.js'

import {
  matsmapsbaseobj,
  modsbaseobj,
} from './differobj.js'

class Utils{
  constructor(){
    this.alldatas={mods:{},mats:{},maps:{}}
    //数据版本号 cookie里的
    this.data_v = {spcial_v:0,mods_v:0,mats_v:0,maps_v:0}
    //所有关键字
    this.userid = 0
    this.matsmapsbaseobj = matsmapsbaseobj
    this.modsbaseobj = modsbaseobj
    this.init()

    this.sucaiurl = ''
    this.ssyzitemid = 0
    this.ssyzitem = null
    this.ssyzitemsucai = ''
    this.inputCode= '';  // 输入的值
    this.checkCode= '';  // 图片验证码的值
    this.expressValue= '';  // 表达式的值
    // canvas各种设置
    this.cvs= {
      w: 100, // 给出默认宽度  宽度会在图片绘制时根据长度更改
      h: 40,  // 高 与input保持一致
      fontSize: 34,   // 字体大小
      str: '+-*',  // 符号生成范围
      line: 4 // 噪音线个数
    }
  }
  init(){
    getappid().then(res=>{
      if(res.data){
        global.aid = this.aid = res.data.aid
      }
    })
    global.tcon = 'Ty_kjmd'
  }
  testssyz(vue){
    if (this.inputCode) {
      if (parseInt(this.inputCode) === this.expressValue) {
        // 验证成功要做的事
        vue.$elMessage("验证成功",'success',false)
        const url = this.ssyzitem.folder;
        this.fromdownload(`${this.sucaiurl}${url}`)
        this.sendusenum(this.ssyzitemid,this.ssyzitemsucai)
        this.inputCode = ''
      } else {
        // 验证码有误
        vue.$elMessage("错误，请重新输入",'warning',false)
        this.inputCode = ''
      }
    } else {
      // 输入为空
      vue.$elMessage("请输入右侧结果",'warning',false)
    }
  }
  getCode(domCvs){
    this.drawCode(domCvs);
  }
  // 随机整数生成器，范围[0, max)
  rInt(max) {
    return Math.floor(Math.random() * 100000 % max);
  }
  // 生成随机表达式
  rCode() {
    let a = this.rInt(100);
    let b = this.rInt(10);
    let op = this.cvs.str.charAt(this.rInt(this.cvs.str.length));
    // 表达式
    let code = `${a}${op}${b}=`;
    this.checkCode = code;
    // 表达式的值
    this.expressValue = eval(code.substr(0, code.length - 1));
    return code;
  }
  // 生成随机颜色 rgba格式
  rColor() {
    let a = ((Math.random()*5 + 5) / 10).toFixed(2);
    return `rgba(${this.rInt(256)}, ${this.rInt(256)}, ${this.rInt(256)}, ${a})`
  }
  // 验证码图片绘制
  drawCode(domCvs) {
    let _this = this;
    // 随机表达式
    let checkCode = this.rCode();
    // 宽设置
    this.cvs.w = 10 + this.cvs.fontSize * this.checkCode.length;
    // 判断是否支持canvas
    if (domCvs !== null && domCvs.getContext && domCvs.getContext('2d')) {
      // 设置显示区域大小
      domCvs.style.width = _this.cvs.w;
      // 设置画板宽高
      domCvs.setAttribute('width', _this.cvs.w);
      domCvs.setAttribute('height', _this.cvs.h);
      // 画笔
      let pen = domCvs.getContext('2d');
      // 背景: 颜色  区域
      pen.fillStyle = '#eee';
      pen.fillRect(0, 0, _this.cvs.w, _this.cvs.h);
      // 水平线位置
      pen.textBaseline = 'middle';   // top middle bottom
      // 内容
      for (let i = 0; i < _this.checkCode.length; i++) {
        pen.fillStyle = _this.rColor(); // 随机颜色
        pen.font = `bold ${_this.cvs.fontSize}px 微软雅黑`; // 字体设置
        // 字符绘制: (字符, X坐标, Y坐标)
        pen.fillText(checkCode.charAt(i), 10 + _this.cvs.fontSize * i, 17 + _this.rInt(10));
      }
      // 噪音线
      for (let i = 0; i < _this.cvs.line; i++) {
        // 起点
        pen.moveTo(_this.rInt(_this.cvs.w) / 2, _this.rInt(_this.cvs.h));
        // 终点
        pen.lineTo(_this.rInt(_this.cvs.w), _this.rInt(_this.cvs.h));
        // 颜色
        pen.strokeStyle = _this.rColor();
        // 粗细
        pen.lineWidth = '4';
        // 绘制
        pen.stroke();
      }
    } else {
      this.$message.error('不支持验证码格式，请升级或更换浏览器重试');
    }
  }
  dedupe(arr){
    let i =0,obj = {},result = [];
    for(i = 0; i< arr.length; i++){
      if(!obj[arr[i].id]){
      obj[arr[i].id] = 1;
      result.push(arr[i]);
      }
    }
    return result;
  }
  copyToClip(content,vue,message) {
    const aux = document.createElement("input"); 
    aux.setAttribute("value", content); 
    document.body.appendChild(aux); 
    aux.select();
    document.execCommand("copy"); 
    document.body.removeChild(aux);
    if (!message) {
      vue.$elMessage("复制成功",'success',false)
    } else{
      vue.$elMessage(message,'success',false)
    }
  }
  //记录滚动条位置
  elescrollTop(route){
    // console.log(route);
    if(route.meta.keepAlive){
      const ele = document.querySelector(route.meta.scrollelename)
      if(ele && route.meta.scrollTop){
        ele.scrollTop = route.meta.scrollTop
      }
    }
  }
  //加密
  encrypt(a) {
    const content = a;
    const cipher = crypto.createCipher('aes192', secretkey); //使用aes192加密
    let enc = cipher.update(content, 'utf8', 'hex'); //编码方式从utf-8转为hex;
    return (enc += cipher.final('hex')); //编码方式转为hex;
  }
  //解密
  decrypt(a) {
    let enc = a;
    //AES对称解密
    const decipher = crypto.createDecipher('aes192', secretkey);
    let dec = decipher.update(enc, 'hex', 'utf8');
    dec += decipher.final('utf8');
    // console.log('AES对称解密结果：' + dec);
    return dec
  }
  //获取cookie
  setCookie(name, value,expires){
    //设置名称为name,值为value的Cookie
    // var expdate = new Date();   //初始化时间
    // expdate.setTime(expdate.getTime() + 30 * 60 * 1000);   //时间
    // document.cookie = name+"="+value+";expires="+expdate.toGMTString()+";path=/";
    document.cookie = `${name}=${value};${expires?`expires=${expires};`:""}path=/;`
    //即document.cookie= name+"="+value+";path=/";   时间可以不要，但路径(path)必须要填写，因为JS的默认路径是当前页，如果不填，此cookie只在当前页面生效！~
  }
  //设置cookie
  getCookie(c_name){
  if (document.cookie.length>0){
    let c_start=document.cookie.indexOf(c_name + "=")
    if (c_start!=-1){
      c_start=c_start + c_name.length+1 
      let c_end=document.cookie.indexOf(";",c_start)
      if (c_end==-1) c_end=document.cookie.length
      return unescape(document.cookie.substring(c_start,c_end))
      } 
    }
    return ""
  }
  //设置所有已加载展示数据的对象集合
  setalldatas(datas,type,utils){
    datas.forEach(i=>{
      this.alldatas[type][i.id]=i
    })
  }
  //from 提交实现下载
  fromdownload(url,vue){
    // 创建form， 添加所需传的参数
    const formHtml = vue?vue.utils.fromele:this.fromele
    formHtml.action = url
    // console.log(formHtml);
    // console.log(formHtml.action);
    formHtml.submit()
  }
  //发送当前下载id到后台 用以记录下载次数
  sendusenum(id,type){
    sendusenum(id,type)
  }
  //对象转url参数
  urlEncode(upath,opt){
    return `/${upath}?sucai=${opt.sucai}${opt.fname?`&fname=${opt.fname}`:""}${opt.classid?`&classid=${opt.classid}`:""}${opt.classcid?`&classcid=${opt.classcid}`:""}${opt.fid?`&fid=${opt.fid}`:""}${opt.search?`&search=${opt.search}`:""}${opt.colorid?`&colorid=${opt.colorid}`:""}${opt.styleid?`&styleid=${opt.styleid}`:""}${opt.px!='id'?`&px=${opt.px}`:""}${opt.type?`&type=${opt.type}`:""}${opt.isone?`&isone=${opt.isone}`:""}${opt.stype?`&stype=${opt.stype}`:""}${opt.page>1?`&page=${opt.page}`:""}`
  }
  //处理搜索字符串
  strhandle(baseobj,str){
    let temparr=[]
    const queryarr = [],
    tempobj={},
    list = str.split(''),
    urlqurey = {}
    let nn=list.length,count
    for(let i in list){
      // console.log(list[i]);
      temparr.push(list[i])
      let num = parseInt(i)+2
      for(let ii=0;ii<nn;ii++){
        if(num<=nn){
          const newl = list.slice(i,num)
          const newstr = newl.join('')
          // console.log(newstr);
          temparr.push(newstr)
        }
        num ++
      }
    }
    temparr.sort((a,b)=>{return a.length>b.length;})
    // console.log(temparr);
    for(let i of temparr){
      const baseobjitem =  baseobj[i]
      if(baseobjitem){
        count = queryarr.length + 1
        queryarr.push([i,baseobjitem])
        tempobj[baseobjitem.t] = count
        // str = str.replace(i," ")
      }
    }
    // console.log('剩余字符串',str);
    // console.log(queryarr);
    // console.log(tempobj);
    // console.log(indexarr);
    for(let i in tempobj){
      const item = queryarr[tempobj[i]-1]
      if(item[1].t == 'classcid'){
        urlqurey[item[1].t] = item[1].id
        urlqurey['classid'] = item[1].type
        urlqurey['fname'] = item[1].fname
      }else if(item[1].t == 'classid'){
        urlqurey[item[1].t] = item[1].id
        urlqurey['fname'] = item[1].fname
      }else{
        urlqurey[item[1].t] = item[1].id
      }
    }
    if(Object.keys(urlqurey).length != 0&&!urlqurey.classcid){urlqurey.classcid = 0}
    // console.log(urlqurey);
    // str:str.replace(/(^\s*)|(\s*$)/g,"")
    return urlqurey
  }
  //返回字符串组合
  returnseekstr(opt){
    let classid = ""+opt.classid,
    classcid = ""+opt.classcid,
    colorid = ""+opt.colorid,
    styleid = ""+opt.styleid,
    page = ""+opt.page
    if(classid.length<2){classid = "0"+classid}
    if(classcid.length<2){classcid = "0"+classcid}
    if(colorid.length<2){colorid = "0"+colorid}
    if(styleid.length<2){styleid = "0"+styleid}
    if(page.length<2){page = "0"+page}
    return `${opt.sucai}${classid}${classcid}${opt.search}${colorid}${styleid}${opt.px}${opt.typeid}${opt.isone}${page}${opt.limit}${opt.stype}`
  }
  //向服务器获取数据
  //后期如果有问题 注意不保存搜索数据
  seekgetitem($store,seekname){
    // console.log('seekgetitem');
    const opt = {
      classid:$store.state[seekname+'query'].classid||0,
      classcid:$store.state[seekname+'query'].classcid||0,
      sucai:$store.state[seekname+'query'].sucai||'',
      search:$store.state[seekname+'query'].search||'',
      colorid:$store.state[seekname+'query'].colorid,
      styleid:$store.state[seekname+'query'].styleid,
      px:$store.state[seekname+'query'].px,
      typeid:$store.state[seekname+'query'].type,
      isone:$store.state[seekname+'query'].isone,
      page:$store.state[seekname+'query'].page,
      limit:$store.state[seekname+'limit'],
      stype:$store.state[seekname+'query'].stype||0,
      maxv:$store.state[seekname+'query'].maxv||0
    }
    // console.log('opt',opt);
    if(opt.stype){
      if(opt.stype == 1){
        opt.search = opt.search.substring(2)
      }else if(opt.stype == 2){
        
      }else{
        opt.search =` ${opt.search} `.replace(/\s/g,"%")
      }
    }
    // let tsucai_v = 0,sucai_v_str = opt.sucai+'_v'
    // try{
    //   tsucai_v = JSON.parse(this.getCookie('data_v'))[sucai_v_str]
    //   if(!tsucai_v){throw new Error('tsucai_v err')}
    //   this.data_v[sucai_v_str] = tsucai_v
    // }catch(e){
    //   getcookies().then(res=>{
    //     // console.log('gcoks',res);
    //     tsucai_v = JSON.parse(this.getCookie('data_v'))[sucai_v_str]
    //     this.data_v[sucai_v_str] = tsucai_v
    //     localStorage.setItem(sucai_v_str,tsucai_v)
    //   })
    // }
    // console.log(opt.stype);
    // const str = this.returnseekstr(opt)
    //// const str = `${opt.sucai}${opt.classid}${opt.classcid}${opt.search}${opt.colorid}${opt.styleid}${opt.px}${opt.typeid}${opt.isone}${opt.page}${opt.limit}${opt.stype}`
    // console.log(str);

    // try{
    //   const datas = JSON.parse(this.decrypt(localStorage.getItem(str)))
    //   ,itemsdata = datas.data
    //   ,total = datas.total
    //   ,data_v = datas.data_v
    //   ,sucai_v = opt.sucai+'_v'
    //   ,v = data_v[sucai_v]
    //   // console.log(datas,v != this.data_v[sucai_v]);
    //   // console.log('预加载');
    //   // console.log('v:',v);
    //   // console.log('this_v_'+sucai_v,this.data_v[sucai_v]);
    //   if(!v || v != this.data_v[sucai_v]){throw new Error("版本号对不上获取新的数据")}
    //   $store.state[seekname+'total'] = total
    //   // let d = this.dedupe(itemsdata)
    //   $store.state[seekname+'sucais'] = itemsdata
    //   // $store.state[seekname+'sucais'] = d
    //   this.setalldatas(itemsdata,opt.sucai)
    // }catch(e){

      // console.log('网路加载');
      // console.log(e);
      switch($store.state[seekname+'query'].sucai){
        case('mods'):d_getmods(opt,(res)=>{
          try{
            if(res.total){$store.state[seekname+'total'] = res.total}else{$store.state[seekname+'total'] = 0}
            if(res.data){
              let d = this.dedupe(res.data)
              $store.state[seekname+'sucais'] = d
              this.setalldatas(d,'mods')
              // localStorage.setItem(str,this.encrypt(JSON.stringify({data:d,data_v:this.data_v,total:res.total})))
            }else{$store.state[seekname+'sucais'] = []}
          }catch(e){$store.state[seekname+'sucais'] = []}
        })
        break;
        case('mats'):d_getmats(opt,(res)=>{
          try{
            if(res.total){$store.state[seekname+'total'] = res.total}else{$store.state[seekname+'total'] = 0}
            if(res.data){
              let d = this.dedupe(res.data)
              $store.state[seekname+'sucais'] = d
              this.setalldatas(d,'mats')
              // localStorage.setItem(str,this.encrypt(JSON.stringify({data:d,data_v:this.data_v,total:res.total})))
            }else{$store.state[seekname+'sucais'] = []}
          }catch(e){$store.state[seekname+'sucais'] = []}
        })
        break;
        case('maps'):d_getmaps(opt,(res)=>{
          try{
            if(res.total){$store.state[seekname+'total'] = res.total}else{$store.state[seekname+'total'] = 0}
            if(res.data){
              let d = this.dedupe(res.data)
              $store.state[seekname+'sucais'] = d
              this.setalldatas(d,'maps')
              // localStorage.setItem(str,this.encrypt(JSON.stringify({data:d,data_v:this.data_v,total:res.total})))
            }else{$store.state[seekname+'sucais'] = []}
          }catch(e){$store.state[seekname+'sucais'] = []}
        })
        break;
      }
    // }
  }
  //登入
  loginhandle(phone,password,vue,isreglog){
    localStorage.setItem('loginphone',phone)
    login(phone,password).then(res=>{
      // console.log(res);
      if(!res){return}
      if(res.state==0){
        if(res.data){
          vue.$elMessage('登入成功','success')
          const yh = res.data.yh
          vue.$store.state.username=yh.name||'图艺模块库会员'
          vue.$store.state.sqlgrid=yh.sqlgrid
          vue.$store.state.phone=yh.phone
          vue.$store.state.role=yh.role
          vue.$store.state.changed=yh.changed
          vue.$store.state.passchanged=yh.passchanged
          vue.$store.state.invitecode=yh.id
          vue.$store.state.id=yh.id
          vue.utils.userid = yh.id
          localStorage.setItem('webyh',this.encrypt(JSON.stringify(yh)))
          localStorage.setItem('loginpassword',this.encrypt(password))
          vue.$store.state.reg_logVisible = false
          if(isreglog){
            vue.loginpassword = ''
            vue.$emit('causechange')
          }
          
          const ife = res.ife
          if(ife == 1){
            sendlogin(yh,1).then(res=>{
              // console.log(res);
            })
          }
        }
      }else{
        vue.$elMessage(res.msg,'error')
        vue.$emit('causechange',res.msg)
      }
    })
  }
  //回到父分类 给dseek pseek tseek seek 使用的公共函数
  gobacktopar(vue,seekname){
    // console.log(seekname);
    const seekname1 = seekname+'query'
    vue.$store.state[seekname1].type=0
    vue.$store.state[seekname1].page=1
    vue.$store.state[seekname1].px='id'
    vue.$store.state[seekname1].styleid=0
    vue.$store.state[seekname1].colorid=0
    vue.$store.state[seekname1].isone=0
    vue.$store.state[seekname1].classcid=0
    vue.$store.state[seekname1].classid=0
    vue.$store.state[seekname+'sucais']=[]
    vue.$router.push(`/${vue.$store.state[seekname1].sucai}`)
  }
}


export default new Utils